export const BEHAVIOR_CROSS_SELL = "cross-sell";
export const BEHAVIOR_INPATH = "inpath";
export const BEHAVIOR_SBXS = "sbxs";
export const CAR_BOOKINGS_ENDPOINT = "/api/car-booking/v1/car/bookings";
export const CARTRAWLER_ENVIRONMENT_PROD = "production";
export const CARTRAWLER_SCRIPT_ELEMENT_ID = "swa-ct-smartblock-loader-script";
export const CARTRAWLER_SECTION_ID = "swa-smartblock";
export const CARTRAWLER_VIEW_BASKET = "basket";
export const CARTRAWLER_VIEW_SELECTED = "selected";
export const CONTEXT_CONFIRM = "confirm";
export const CONTEXT_INPATH = "inpath";
export const CONTEXT_SEARCH = "search";
// TODO: move language codes to WCM post MVP
export const LANGUAGE_CODES = {
  en: "en-us",
  es: "mx",
};
export const ORDER_ID_CONTEXT = "ORDERID";
export const PAGE_TYPE_PRIMARY = "primary";
export const PAGE_TYPE_SECONDARY = "secondary";
export const PARAMETER_PARTNER_CODES_ENVIRONMENT = "environment";
export const TOUCHPOINT_BOOK_A_CAR = "book_a_car";
export const TOUCHPOINT_HOMEPAGE = "homepage";
